var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueCross(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#14BAD8",
    fillRule: "evenodd",
    d: "M18.657 5.343a1 1 0 0 1 0 1.414L13.414 12l5.243 5.243a1 1 0 0 1 .078 1.327l-.078.087a1 1 0 0 1-1.414 0L12 13.414l-5.243 5.243a1 1 0 0 1-1.327.078l-.087-.078a1 1 0 0 1 0-1.414L10.586 12 5.343 6.757a1 1 0 0 1-.078-1.327l.078-.087a1 1 0 0 1 1.414 0L12 10.585l5.243-5.242a1 1 0 0 1 1.327-.078z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueCross);
export default __webpack_public_path__ + "static/media/blue-cross.76ddd9a536b7688ad0de8b93fdc5cc83.svg";
export { ForwardRef as ReactComponent };